import { useSubscriber } from '@texas/messageBus/useMessageBus';
import { useValueDisclosure } from '@texas/hooks/useValueDisclosure';
import { SetGarpDataModal } from '../article/productApproval/setGarpData/SetGarpDataModal';
import { ConfigureCompositionGroupGarp } from '@texas/messageBus/messages';
import { reactEvents } from '@bridge/reactEvents';

interface Props {
  children: React.ReactNode;
}

export function ConfigureProductApproval({ children }: Props) {
  const { value, onOpen, onClose, isOpen } =
    useValueDisclosure<ConfigureCompositionGroupGarp>();

  useSubscriber(ConfigureCompositionGroupGarp, (data) => {
    onOpen(data);
  });

  return (
    <>
      {children}
      {value && (
        <SetGarpDataModal
          compositionGroupId={value.compositionGroupId}
          productApprovalId={value.productApprovalId}
          variantId={value.variantId}
          branchId={value.branchId}
          isOpen={isOpen}
          onClose={() => {
            onClose();
            // Nasty hack since we have a race condition where the GARP data is not yet updated when the modal is closed, causing the overview to not update.
            // This ensures the overview is updated after the modal is closed.
            // When Garp page is in react, we can make this a lot better
            setTimeout(() => {
              reactEvents.garpDataUpdated.dispatch();
            }, 800);
          }}
        />
      )}
    </>
  );
}
